import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { searchMangas, getHotMangas } from '@/mocks/manga';

export default function SearchResults({ keyword }: { keyword: string }) {
  const results = searchMangas(keyword);
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-700">
            <i className="ri-search-line"></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
              搜索“{keyword}”的结果
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              共找到 {results.length} 部相关漫画
            </p>
          </div>
        </div>

        {results.length > 0 ? (
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
            {results.map((m) => (
              <MangaCard key={m.id} manga={m} />
            ))}
          </div>
        ) : (
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-10 text-center">
            <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
            <h3 className="mt-3 text-lg font-bold text-foreground-900">没有找到相关漫画</h3>
            <p className="mt-2 text-sm text-foreground-600">
              换个关键词，或按下面的热门作品看看～
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
              {getHotMangas(5).map((m) => (
                <MangaCard key={m.id} manga={m} />
              ))}
            </div>
            <Link
              to="/"
              className="mt-6 inline-flex whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}